// firebase.js - في النهاية
import { initializeApp } from 'firebase/app'
import { getMessaging, getToken, isSupported, onMessage } from 'firebase/messaging'

const firebaseConfig = {
   apiKey: "AIzaSyD-GblsejBGp4HQ7FutiVTWkkVrJn_2C5Y",
   authDomain: "fast-link-bae35.firebaseapp.com",
   projectId: "fast-link-bae35",
   storageBucket: "fast-link-bae35.firebasestorage.app",
   messagingSenderId: "165180701911",
   appId: "1:165180701911:web:c5b69f4ec865ec3957c492"
};

const app = initializeApp(firebaseConfig);

export let messaging = null;
isSupported().then(supported => {
   if (supported) {
      messaging = getMessaging(app);
   } else {
      console.warn('🔕 Firebase messaging not supported in this browser.');
   }
});

export const requestPermission = async () => {
   if (!messaging) {
      return null;
   }
   const permission = await Notification.requestPermission();
   if (permission !== 'granted') {
      console.warn('🚫 Notification permission denied.');
      return null;
   }

   if (permission === "granted") {
      try {
         const token = await getToken(messaging, {
            vapidKey: "BHVmXFdX0ZWE89E8PnpBjmCzxkUrWtHmDd1mHYoIcPOorqzu1VbdjKm0EuUU5hVXULqtOsCdslUuEwJX-jR_r-I"
         })
         return token;
      } catch (error) {
         console.error("Error getting FCM token", error);
         return null;
      }
   } else {
      return null;
   }
};

export const onMessageListener = () =>
   new Promise((resolve) => {
      if (!messaging) return;
      onMessage(messaging, (payload) => {
         resolve(payload);
      });
   });

/**
 * ✅ دالة جديدة: الحصول على FCM token بدون طلب Permission
 * تستخدم بعد نجاح التثبيت
 */
export const getFCMToken = async () => {
   try {
      if (!messaging) {
         console.warn('🔕 Firebase messaging not initialized');
         return null;
      }

      // التحقق من Permission الحالي
      const permission = Notification.permission;

      if (permission === 'granted') {
         const token = await getToken(messaging, {
            vapidKey: "BHVmXFdX0ZWE89E8PnpBjmCzxkUrWtHmDd1mHYoIcPOorqzu1VbdjKm0EuUU5hVXULqtOsCdslUuEwJX-jR_r-I"
         });
         return token;
      } else if (permission === 'default') {
         // يمكن طلب Permission
         return await requestPermission();
      } else {
         // مرفوض
         console.warn('🚫 Notification permission denied');
         return null;
      }
   } catch (error) {
      console.error('❌ Error getting FCM token:', error);
      return null;
   }
};
